import { z } from "zod";

export const flashcardsInputSchema = z.object({
  phrase: z
    .string({ required_error: "A phrase is required to generate flashcards" })
    .transform((p) => p.trim()),
});

export const flashcardsOutputSchema = z.object({
  name: z.string(),
  type: z.string(),
  id: z.string().optional(),
  items: z.array(
    z.object({
      note: z.string(),
      word: z.string(),
      translation: z.string(),
    }),
  ),
});

export const getFlashcardsParams = z.object({
  flashcards_id: z.string().cuid(),
});

export type FlashcardsApiInput = z.infer<typeof flashcardsInputSchema>;
